import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowLeft, MapPin, Info } from 'lucide-react';
export function UserJourneyMap() {
  return <div className="min-h-screen bg-gradient-to-br from-slate-50 via-white to-slate-50" data-id="element-3704">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-3705">
        {/* Header */}
        <div className="mb-12" data-id="element-3706">
          <Link to="/ux" className="inline-flex items-center gap-2 text-sm font-medium text-slate-600 hover:text-slate-900 transition-colors mb-6" data-id="element-3707">
            <ArrowLeft size={16} data-id="element-3708" />
            Back to UX Documentation
          </Link>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} data-id="element-3709">
            <h1 className="text-4xl font-bold text-slate-900 mb-4" data-id="element-3710">
              User Journey Map
            </h1>
            <p className="text-lg text-slate-600 max-w-3xl" data-id="element-3711">
              Visual representation of how users interact with the platform
              across different stages and touchpoints.
            </p>
          </motion.div>
        </div>

        {/* Coming Soon Placeholder */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.2
      }} className="bg-white/60 backdrop-blur-xl border border-slate-200/50 rounded-2xl p-12 text-center" data-id="element-3712">
          <div className="max-w-2xl mx-auto" data-id="element-3713">
            <div className="inline-flex p-4 bg-cyan-50 rounded-2xl mb-6" data-id="element-3714">
              <MapPin size={48} className="text-cyan-600" data-id="element-3715" />
            </div>

            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-3716">
              Journey Map Coming Soon
            </h2>

            <p className="text-slate-600 leading-relaxed mb-8" data-id="element-3717">
              We're currently mapping out detailed user journeys for each
              persona, including touchpoints, emotions, pain points, and
              opportunities for improvement at each stage of interaction.
            </p>

            <div className="bg-blue-50/50 backdrop-blur-xl border border-blue-100/50 rounded-xl p-6 text-left" data-id="element-3718">
              <div className="flex items-start gap-3" data-id="element-3719">
                <div className="p-2 bg-blue-100 rounded-lg flex-shrink-0" data-id="element-3720">
                  <Info size={20} className="text-blue-600" data-id="element-3721" />
                </div>
                <div data-id="element-3722">
                  <h3 className="text-sm font-semibold text-blue-900 mb-2" data-id="element-3723">
                    What to Expect
                  </h3>
                  <ul className="space-y-2 text-sm text-blue-700" data-id="element-3724">
                    <li className="flex items-start gap-2" data-id="element-3725">
                      <span className="text-blue-600 font-bold mt-0.5" data-id="element-3726">•</span>
                      <span data-id="element-3727">Stage-by-stage breakdown of user interactions</span>
                    </li>
                    <li className="flex items-start gap-2" data-id="element-3728">
                      <span className="text-blue-600 font-bold mt-0.5" data-id="element-3729">•</span>
                      <span data-id="element-3730">
                        Emotional journey mapping (frustrations and delights)
                      </span>
                    </li>
                    <li className="flex items-start gap-2" data-id="element-3731">
                      <span className="text-blue-600 font-bold mt-0.5" data-id="element-3732">•</span>
                      <span data-id="element-3733">Touchpoint identification across channels</span>
                    </li>
                    <li className="flex items-start gap-2" data-id="element-3734">
                      <span className="text-blue-600 font-bold mt-0.5" data-id="element-3735">•</span>
                      <span data-id="element-3736">Opportunity areas for product improvement</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </motion.div>

        {/* Placeholder for future journey stages */}
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.5,
        delay: 0.4
      }} className="mt-8 grid grid-cols-1 md:grid-cols-4 gap-4" data-id="element-3737">
          {['Awareness', 'Consideration', 'Usage', 'Advocacy'].map((stage, index) => <div key={stage} className="bg-white/40 backdrop-blur-xl border border-slate-200/30 rounded-xl p-6 text-center opacity-50" data-id="element-3738">
                <div className="w-12 h-12 bg-slate-100 rounded-full mx-auto mb-3 flex items-center justify-center" data-id="element-3739">
                  <span className="text-slate-400 font-bold" data-id="element-3740">{index + 1}</span>
                </div>
                <h3 className="text-sm font-semibold text-slate-600" data-id="element-3741">
                  {stage}
                </h3>
              </div>)}
        </motion.div>
      </div>
    </div>;
}